"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceToJSON = exports.DataSourceFromJSONTyped = exports.DataSourceFromJSON = exports.DataSource = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var DataSource;
(function (DataSource) {
    DataSource["OVERWOLF"] = "OVERWOLF";
    DataSource["BLITZ"] = "BLITZ";
    DataSource["ACTIVSION"] = "ACTIVSION";
})(DataSource = exports.DataSource || (exports.DataSource = {}));
function DataSourceFromJSON(json) {
    return DataSourceFromJSONTyped(json, false);
}
exports.DataSourceFromJSON = DataSourceFromJSON;
function DataSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DataSourceFromJSONTyped = DataSourceFromJSONTyped;
function DataSourceToJSON(value) {
    return value;
}
exports.DataSourceToJSON = DataSourceToJSON;
